import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import type { ApiResponse, CategoryResponse, PageInfo } from '../../models';

/** Public Used Tech HTTP endpoints. No app state or server-rendering dependencies. */
@Injectable({ providedIn: 'root' })
export class RefurbishedStorefrontApiService {
  private readonly baseUrl: string;

  constructor(private readonly http: HttpClient, @Inject('API_URL') apiUrl: string, @Inject('API_VERSION') version: string) {
    this.baseUrl = `${apiUrl}/api/${version}`;
  }

  page<T>(path: string, page: number, limit: number, params: Record<string, string> = {}) {
    return this.http.get<ApiResponse<{ records: T[]; pagination: PageInfo }>>(`${this.baseUrl}/refurbish/${path}`, {
      params: { page, limit, ...params }
    });
  }

  category(id: string | number) {
    return this.http.get<ApiResponse<CategoryResponse>>(`${this.baseUrl}/category/${encodeURIComponent(id)}`);
  }
}
